export const routes = {
  project: "/project/:id",
  departmentOverview: "/department-overview",
  templates: "/templates",
  baseTemplate: "/template/:id",
  templateComponents: "/sub-templates",
  subTemplate: "/sub-template/:id",
  syncStatus: "/sync-status",
  totalProjectOverview: "/total-project-overview",
  syncStatusDetails: "/sync-status/:id",
  login: "/Login",
  projects: "/",
  settings: "/settings",
  replaceRedirect: "/r-redirect",
  callback: "/callback",
};

export const defaultViewPreset = "weekNumbersPreset";

export const ViewTypes = {
  ProjectView: 0,
  DepartmentsOverView: 1,
  ProjectsOverview: 2
}

export const ErpConnectionTypes = {
  RidderiQ: "RidderiQ",
  RidderiQApi: "RidderiQApi",
  ProteusApi: "ProteusApi",
  BemetApi: "BemetApi",
}

